import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { DEFAULT_PAGE_SIZE } from "~/common/constants";
import { getPatients } from "~/providers/api/patients";
import { PATIENT_FILTER_PARAMS } from "~/providers/constants";
import { ENGAGEMENT_TYPES } from "~/providers/constants/patientSearchConstants";

export const useGetPatients = (params: URLSearchParams, enabled?: boolean) => {
  !params.has(PATIENT_FILTER_PARAMS.pageSize) &&
    params.append(PATIENT_FILTER_PARAMS.pageSize, DEFAULT_PAGE_SIZE);

  !params.has(PATIENT_FILTER_PARAMS.engagements) &&
    params.append(PATIENT_FILTER_PARAMS.engagements, ENGAGEMENT_TYPES.active);

  return useQuery({
    queryFn: () => getPatients(params),
    queryKey: ["getPatients", params.toString(), params],
    enabled,
    placeholderData: keepPreviousData,
  });
};
